<template>
  <div class="ebook-media bg-color-light">
    <div
      class="ebook-media__head full-width display-flex-center justify-content-between effect-transition-fast"
      :class="{'keep-mouse': hideHeadFoot}"
    >
      <a 
        href="javascript:;"
        class="ebook-media__back color-light display-flex-center border-rd-20"
        @click="backReadBook"
      >
        <span class="icon-arrow-left color-light"><span class="path1"></span><span class="path2"></span></span>
        <span class="only-pc">Trở lại</span>
      </a>
      <h2 class="ebook-media__title font-size-17 font-sanpro-semibold color-light margin-0">{{ mediaMain && mediaMain.titleLink ? mediaMain.titleLink : (mediaMain && mediaMain.title?mediaMain.title:'' ) }}</h2>
      <div class="ebook-media__count display-flex-center">
        <p class="margin-0 display-flex-center color-light font-sanpro-light">
          <i class="icon-eye color-light font-size-18" />
          {{ mediaMain && mediaMain.countView ? mediaMain.countView : 0 }}
        </p>
        <p class="margin-0 display-flex-center color-light font-sanpro-light">
          <i class="icon-download color-light font-size-18" />
          {{ mediaMain && mediaMain.countDownload ? mediaMain.countDownload : 0 }}
        </p>
      </div>
    </div>
    <div class="ebook-media__body full-box custom-toolbar">
      <PreviewMedia
        v-if="mediaBookViewing && mediaBookViewing.linkPages && mediaBookViewing.linkPages.length > 0 && mediaMain"
        :dataSource="mediaMain"
        :volumeVal="volumeVal.toString()"
        @checkTypeMedia="handleCheckTypeMediaCurr"
        @ended="handleNextMedia"
      />
      <div
        v-if="mediaBookViewing && mediaBookViewing.linkPages && mediaBookViewing.linkPages.length > 1"
        class="ebook-media__list effect-transition-fast"
        :class="{'active': toggleListPage, 'keep-mouse': hideHeadFoot}"
      >
        <div class="ebook-media__list__head display-flex-center justify-content-center cursor-pointer" @click="handleToggleListPage">
          <i class="icon-arrow-double-down color-light font-size-20"></i>
        </div>
        <div class="ebook-media__list__body custom-scroll custom-scroll--dark">
          <div
            v-for="(item, index) of mediaBookViewing.linkPages"
            :key="index"
            class="item display-flex"
            :class="{'active': index === indexMediaMain}"
            @click="viewMediaInDocSlider(index, 'MediaMain')"
          >
            <figure class="item__img margin-0 position-rel border-rd-4">
              <!-- <img :src="item.posterLink ? `${urlImgCms}/${item.posterLink}` : img404" alt="Học liệu"> -->
              <!-- <img :src="(item.posterLink ? `${urlImgCms}/${item.posterLink}` : `${appUrl}/${item.linkUrl}`) || (item.linkUrl ? `${appUrl}/${item.linkUrl}` : img404)" alt="Học liệu"> -->
              <img :src="item.posterLink ? `${urlImgCms}/${item.posterLink}` : item.linkUrl ? `${appUrl}/${item.linkUrl}` : img404" alt="Học liệu">
            </figure>
            <div class="item__body">
              <h4 class="item__title font-size-16 font-sanpro color-light">{{ item.titleLink }}</h4>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="relateMedia && relateMedia.length>0"
        class="ebook-media__list effect-transition-fast"
        :class="{'active': toggleListPageRelate, 'keep-mouse': hideHeadFoot}"
      >
        <div class="ebook-media__list__head display-flex-center justify-content-center cursor-pointer" @click="handleToggleListPageRelate">
          <i class="icon-arrow-double-down color-light font-size-20"></i>
        </div>
        <div class="ebook-media__list__body custom-scroll custom-scroll--dark">
          <div
            v-for="(item, index) of relateMedia"
            :key="index"
            class="item display-flex"
            :class="{'active': index === indexMediaMain}"
            @click="viewMediaInDocSlider(index, 'Relate')"
          >
            <figure class="item__img margin-0 position-rel border-rd-4">
              <img :src="item.posterLink ? `${urlImgCms}/${item.posterLink}` : item.linkUrl ? `${appUrl}/${item.linkUrl}` : img404" alt="Học liệu">
            </figure>
            <div class="item__body">
              <h4 class="item__title font-size-16 font-sanpro color-light">{{ item.title }}</h4>
            </div>
          </div>
        </div>
      </div>


      <div
        v-if="infoBook"
        class="ebook-media__list effect-transition-fast"
        :class="{'active': toggleInfoCourse, 'keep-mouse': hideHeadFoot}"
      >
        <div class="ebook-media__list__head display-flex-center justify-content-center cursor-pointer" @click="handleToggleInfoCourse">
          <i class="icon-arrow-double-down color-light font-size-20"></i>
        </div>
        <div class="ebook-media__list__body custom-scroll custom-scroll--dark">
          <div class="item">
            <div class="">
              <h4 class="item__title font-size-16 font-sanpro color-light">Sách: {{infoBook.bookName}}</h4>
            </div>
            <div class="">
              <h4 class="item__title font-size-16 font-sanpro color-light">Bộ sách: {{infoBook.bookGroupName}}</h4>
            </div>
            <div class="">
              <h4 class="item__title font-size-16 font-sanpro color-light">Chương/Tuần: {{infoBook.bookIndexParentName}}</h4>
            </div>
            <div class="">
              <h4 class="item__title font-size-16 font-sanpro color-light">Bài: {{infoBook.bookIndexName}}</h4>
            </div>
            <div class="">
              <h4 class="item__title font-size-16 font-sanpro color-light">Trang: {{this.pageRead}}-{{this.pageRead+1}}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="ebook-media__footer full-width effect-transition-fast"
      :class="{'keep-mouse': hideHeadFoot}"
    >
      <div v-show="isMediaVideoAudio" class="video-progress ebook-media__footer__progress full-width">
        <progress id="progress-bar" class="full-width" value="0" min="0" ref="progressbar"></progress>
        <input ref="seek" class="seek full-width cursor-pointer" id="seek" value="0" min="0" type="range" step="1">
        <div ref="seek_tooltip" class="seek-tooltip display-none font-size-12 color-light font-sanpro-light" id="seek-tooltip">00:00</div>
      </div>
      <div class="ebook-media__footer__main full-width display-flex-center justify-content-between" :class="{'has-media': isMediaVideoAudio}">
      <div class="list-tab-suggest-ebook">
        <a
          v-if="mediaBookViewing && mediaBookViewing.linkPages && mediaBookViewing.linkPages.length > 1"
          href="javascript:;"
          class="ebook-media__list__toggle color-light display-flex-center border-rd-20"
          :class="{'btn-gray-dark': toggleListPage}"
          @click="handleToggleListPage"
        >
          <span class="icon-nhom-hoc-lieu-3 font-size-30"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span></span>
          Nhóm học liệu ({{ mediaBookViewing && mediaBookViewing.linkPages ? mediaBookViewing.linkPages.length : '0' }})
        </a>
       <a
          
          href="javascript:;"
          class="ebook-media__list__toggle color-light display-flex-center border-rd-20"
          :class="{'btn-gray-dark': toggleListPageRelate}"
          @click="handleToggleListPageRelate"
        >
          <img src="@/assets/images/playsuggest.png" />
          Học liệu liên quan
        </a>

        <a
          
          href="javascript:;"
          class="ebook-media__list__toggle color-light display-flex-center border-rd-20"
          :class="{'btn-gray-dark': toggleInfoCourse}"
          @click="handleToggleInfoCourse"
        >
          <img src="@/assets/images/CompositeLayer.png" />
          Thông tin học liệu
        </a>
      </div>
        

        <div class="ebook-media__controls display-flex-center">
          <div
            v-if="mediaBookViewing && mediaBookViewing.linkPages && mediaBookViewing.linkPages.length > 1"
            class="ebook-media__prev cursor-pointer size-btn-30 border-rd-20"
            :class="{'disabled': indexMediaMain === 0}"
            @click="handlePrevMedia"
          >
            <i class="icon-first-page color-light font-size-20" />
          </div>
          <div v-show="isMediaVideoAudio" class="ebook-media__play cursor-pointer">
            <!-- SVG use in video custom - child component svg -->
            <button data-title="Play (k)" id="play" class="border-0 bg-transparent font-size-18">
              <svg class="playback-icons">
                <use href="#play-icon"></use>
                <use class="hidden" href="#pause"></use>
              </svg>
            </button>
          </div>
          <div
            v-if="mediaBookViewing && mediaBookViewing.linkPages && mediaBookViewing.linkPages.length > 1"
            class="ebook-media__next cursor-pointer size-btn-30 border-rd-20"
            :class="{'disabled': !mediaBookViewing || !mediaBookViewing.linkPages || mediaBookViewing.linkPages.length < 2 || (mediaBookViewing && mediaBookViewing.linkPages.length && indexMediaMain === mediaBookViewing.linkPages.length -1)}"
            @click="handleNextMedia"
          >
            <i class="icon-last-page color-light font-size-20" />
          </div>
        </div>
        
        <div class="ebook-media__actions display-flex-center">
          <div v-show="isMediaVideoAudio" class="volume-controls display-flex-center cursor-pointer">
            <button ref="volume_btn" class="volume-button border-0 size-btn-30 border-rd-20" id="volume-button">
              <i v-if="volumeVal < 0.2" class="icon-mute font-size-20 color-light" @click="handleSetVolume(1)" />
              <i v-else class="icon-unmute font-size-20 color-light" @click="handleSetVolume(0)" />
            </button>
            <div class="volume-controls__progress position-rel display-flex-center">
              <progress id="progress-bar__volume" class="full-width" :value="volumeVal" min="0" max="1"></progress>
              <input class="volume slider" id="volume" v-model="volumeVal" data-mute="0.5" type="range" max="1" min="0" step="0.01">
            </div>
          </div>
          <div class="ebook-media__share cursor-pointer border-rd-50 size-btn-30" @click="handleShareMedia">
            <i class="icon-share-white color-light font-size-17" />
          </div>
          <div
            class="ebook-media__download cursor-pointer border-rd-50 size-btn-30"
            @click="handleDownloadFile(mediaBookViewing.linkPages[indexMediaMain].linkUrl, mediaBookViewing.linkPages[indexMediaMain].titleLink)"
          >
            <i class="icon-download color-light font-size-16" />
          </div>
        </div>
      </div>
    </div>
    <ModalShare />
    <svg class="display-none">
      <defs>
        <symbol id="pause" viewBox="0 0 24 24">
          <path d="M14.016 5.016h3.984v13.969h-3.984v-13.969zM6 18.984v-13.969h3.984v13.969h-3.984z"></path>
        </symbol>
        <symbol id="play-icon" viewBox="0 0 24 24">
          <path d="M8.016 5.016l10.969 6.984-10.969 6.984v-13.969z"></path>
        </symbol>
      </defs>
    </svg>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { STORE_KEY } from './../../_store/constants'
import ModalShare from '@/modules/libraries/_components/detail/ModalShare.vue'
// import vueCustomScrollbar from 'vue-custom-scrollbar'
import { updatecountview, apiUpdateCountdownload } from '@/store/common/api'
import { FLE_DOWNLOAD_BEFORE } from '@/store/common/constants'
import { APP_CONFIG } from '@/utils/constants'
import mixinsFiles from '@/components/content-files/mixinsFiles'
import PreviewMedia from './PreviewMedia.vue'
import { debounce } from 'debounce'
import { getAuth } from '@/utils/jwt'
import { EMAIL_PUBLIC } from '@/store/auth/constants'
import { getBookRelate, getMediaDetailInLibs } from './../../_api/'

const img404 = require(`@/assets/images/img_404.jpg`)

export default {
  name: 'EbookMedia',
  mixins: [ mixinsFiles ],
  components: {
    ModalShare,
    // vueCustomScrollbar,
    PreviewMedia
  },
  data () {
    return {
      volumeVal: 1,
      playMedia: false,
      appUrl: APP_CONFIG.bookCdnUrl,
      cdnUrl: APP_CONFIG.cdnUrl,
      imgUrlCms: APP_CONFIG.urlPlatformCmsImg,
      urlImgCms: APP_CONFIG.urlPlatformCmsImg,
      img404,
      indexMediaMain: 0,
      mediaMain: null,
      hideHeadFoot: false,
      toggleListPage: true,
      isMediaVideoAudio: true,
      toggleListPageRelate: false,
      relateMedia: [],
      toggleInfoCourse: false,
      infoBook:null,
      pageRead:0
    }
  },
  computed: {
    ...mapState(STORE_KEY, ['mediaBookViewing', 'ebooksDetail']),
    authInfo () {
      return getAuth()
    }
  },
  watch: {
    mediaBookViewing () {
      this.setMediaMain()
    }
  },
  created () {
    document.addEventListener('mousemove', () => {
      this.showControls()
    });
    document.addEventListener('click', () => {
      this.showControls()
    });
  },
  mounted () {
    this.setMediaMain()
    this.getInfoBook()
    this.pageRead =  parseInt(this.$route.query.pageRead)
  },
  beforeDestroy () {
    document.removeEventListener('mousemove', this.showControls())
    document.removeEventListener('click', this.showControls())
  },
  methods: {
    ...mapActions(STORE_KEY, ['acSetMediaBookViewing']),
    ...mapActions('auth', ['setToggleLoginForm']),
    ...mapActions('common', ['setToggleModalDocSlider', 'setDocPreviewSlider', 'setLoading', 'acToggleModalActiveBook', 'acToggleModalShareMedia', 'acSetMediaShareInfo', 'acToggleModaShowError', 'actionCheckRouterHelp', 'actionSetCountView']),

    handleToggleListPage () {
      this.toggleListPage = !this.toggleListPage
      this.toggleListPageRelate = false
      this.toggleInfoCourse = false
    },
    handleToggleListPageRelate () {
      this.toggleListPageRelate = !this.toggleListPageRelate
      this.toggleListPage = false
      this.toggleInfoCourse = false
    },
    handleToggleInfoCourse(){
      this.toggleInfoCourse = !this.toggleInfoCourse
      this.toggleListPage = false
      this.toggleListPageRelate =  false
    },
    setMediaMain (type='MediaMain') {
      if(type == 'MediaMain'){
        if (this.mediaBookViewing && this.mediaBookViewing.linkPages && this.indexMediaMain > -1) {
          this.mediaMain = this.mediaBookViewing.linkPages[this.indexMediaMain]
          // Request 
          updatecountview(this.mediaMain.pageLinksId).then(res => {
            if(res && res.status === 'success') {
              this.actionSetCountView(Math.random())
            }
          })
          this.getRelateMedia(this.mediaMain.pageLinksId)
        } 
      }else{
        if (this.relateMedia && this.relateMedia.length>0 && this.indexMediaMain > -1) {
          this.mediaMain = this.relateMedia[this.indexMediaMain]
          // Request 
          updatecountview(this.mediaMain.pageLinksId).then(res => {
            if(res && res.status === 'success') {
              this.actionSetCountView(Math.random())
            }
          })
          this.getRelateMedia(this.mediaMain.pageLinkId)
        } 
      }
      
    },
    getRelateMedia(pageLinksId){
      let param ={id:pageLinksId,pageIndex:1,pageSize:20}
      getBookRelate(param).then((response)=>{
        this.relateMedia = response.data
      })

    },
    getInfoBook(){
      getMediaDetailInLibs(this.mediaMain.pageLinksId).then((response)=>{
        this.infoBook = response.data
      })
    },
    backReadBook () {
      this.acSetMediaBookViewing({})
      this.$router.replace({ query: null })
    },

    handleSetVolume (val) {
      this.volumeVal = val.toString()
    },

    handleShareMedia () {
      this.acSetMediaShareInfo({ ...this.mediaBookViewing, ...this.mediaBookViewing.linkPages[this.indexMediaMain] })
      this.acToggleModalShareMedia(true)
    },

    viewMediaInDocSlider (index, type='MediaMain') {
      this.mediaMain = null
      this.indexMediaMain = index
      setTimeout(() => {
        this.setMediaMain(type)
      }, 5)
    },

    showControls () {
      this.hideHeadFoot = false
      this.hideControls()
    },

    hideControls: debounce(function (e) {
      this.hideHeadFoot= true
    }, 3000),

    handleDownloadFile (link, name, id) {
      if(this.authInfo && this.authInfo.email === EMAIL_PUBLIC) {
        this.setToggleLoginForm(true)
      } else {
        apiUpdateCountdownload(id)
        this.downloadDocs(link, `${FLE_DOWNLOAD_BEFORE} ${name}`)
        this.mediaMain.countDownload += 1
      }
    },
    
    handlePrevMedia () {
      this.viewMediaInDocSlider(this.indexMediaMain - 1)
    },
    
    handleNextMedia () {
      if (this.mediaBookViewing.linkPages && this.mediaBookViewing.linkPages.length > 1 && this.indexMediaMain < this.mediaBookViewing.linkPages.length - 1) {
        this.viewMediaInDocSlider(this.indexMediaMain + 1)
      }
    },

    handleCheckTypeMediaCurr (val) {
      this.isMediaVideoAudio = val
    }
  }
}
</script>

<style lang="scss" scoped>
.size-btn-30 {
  width: 30px;
  height: 30px;
  @extend .bg-transparent;
  @extend .display-flex-center;
  @extend .justify-content-center;

  &:hover {
    @extend .btn-gray-dark;
  }
}
.list-tab-suggest-ebook{
  display:flex;
}
.ebook-media {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;

  &__head, &__footer {
    position: fixed;
    left: 0;
    background: $color_gray_view_docs;
    z-index: 2;
    transform: translateY(0);
      -webkit-transform: translateY(0);
  }
  
  &__head {
    padding: 0 20px;
    top: 0;
    height: 50px;

    &.keep-mouse {
      transform: translateY(-100px);
      -webkit-transform: translateY(-100px);
    }
  }

  &__footer {
    bottom: 0;
    height: 70px;
    
    &__main {
      padding: 0 20px;

      &:not(.has-media) {
        height: calc(100% - 8px);
      }
    }

    &.keep-mouse {
      transform: translateY(30vh);
      -webkit-transform: translateY(30vh);
    }
  }

  &__body {
    overflow-y: auto;
  }

  &__back {
    padding: 3px 12px;
    border: 1px solid transparent;

    i, >span {
      margin-right: 5px;
    }

    &:hover {
      @extend .btn-gray-dark;
    }
  }

  &__list {
    position: absolute;
    bottom: 0;
    left: 15px;
    z-index: 1;
    width: 340px;
    background: $color_gray_view_docs;
    border-radius: 10px 10px 0 0;
    bottom: -80vh;

    &.active {
      bottom: 70px;

      &.keep-mouse {
        bottom: 0;
      }
    }

    &__head {
      padding: 5px 10px;
    }

    &__body {
      max-height: 40vh;
      overflow-y: auto;

      .item {
        padding: 8px 10px;
        &__img {
          width: 90px;
          margin-right: 10px;
        }

        &__body {
          width: calc(100% - 100px);
        }

        &.active, &:hover {
          background: darken($color_gray_view_docs, 10)
        }
      }
    }

    &__toggle {
      padding: 5px 10px;
      border: 1px solid transparent;

      >span {
        margin-right: 6px;
      }

      &:hover {
        @extend .btn-gray-dark;
      }
    }
  }

  &__list-relate {
    position: absolute;
    bottom: 0;
    left: 360px;
    z-index: 1;
    width: 340px;
    background: $color_gray_view_docs;
    border-radius: 10px 10px 0 0;
    bottom: -80vh;

    &.active {
      bottom: 70px;

      &.keep-mouse {
        bottom: 0;
      }
    }

    &__head {
      padding: 5px 10px;
    }

    &__body {
      max-height: 40vh;
      overflow-y: auto;

      .item {
        padding: 8px 10px;
        &__img {
          width: 90px;
          margin-right: 10px;
        }

        &__body {
          width: calc(100% - 100px);
        }

        &.active, &:hover {
          background: darken($color_gray_view_docs, 10)
        }
      }
    }

    &__toggle {
      padding: 5px 10px;
      border: 1px solid transparent;

      >span {
        margin-right: 6px;
      }

      &:hover {
        @extend .btn-gray-dark;
      }
    }
  }

  &__controls, &__count, &__actions {
    >* {
      &:not(:last-child) {
        margin-right: 15px;
      }
    }
  }

  &__count {
    i {
      margin-right: 5px;
    }
  }
}
.playback-icons {
  width: 46px;
  height: 46px;
  fill: $color_light;
  stroke: $color_light;
}
.video-progress {
  position: relative;
  height: 8.4px;
  margin-bottom: 5px;
}

.video-progress, .volume-controls__progress {
  progress {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 2px;
    height: 6px;
    pointer-events: none;
    position: absolute;
    left: 0;

    &::-webkit-progress-bar {
      background-color: #879AA9;
      border-radius: 2px;
    }

    &::-webkit-progress-value {
      background: $primary_color;
      border-radius: 2px;
    }
    &::-moz-progress-bar {
      border: 1px solid $primary_color;
      background: $primary_color;
    }
  }
}
.video-progress {
  progress {
    top: 0;
  }
}
.volume-controls__progress {
  min-width: 120px;
  height: 20px;
  
  progress {
    @extend .position-center-y;

    &::-webkit-progress-value {
      background: $color_light;
    }

    &::-moz-progress-bar {
      border: 1px solid $color_light;
      background: $color_light;
    }
  }
}
.seek {
  position: absolute;
  top: 0;
  margin: 0;
}

.seek:hover+.seek-tooltip {
  display: block;
}

.seek-tooltip {
  position: absolute;
  top: -50px;
  margin-left: -20px;
  padding: 3px;
  content: attr(data-title);
  background-color: rgba($color_dark, 0.6);
}

.volume-button {
  width: 30px;
  height: 30px;
  @extend .bg-transparent;

  &:hover {
    @extend .btn-gray-dark;
  }
}

input[type=range] {
  -webkit-appearance: none;
  -moz-appearance: none;
  height: 8.4px;
  background: transparent;
  cursor: pointer;
  padding: 0!important; 
}

input[type=range]:focus {
  outline: none;
}

input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  cursor: pointer;
  border-radius: 1.3px;
  -webkit-appearance: none;
  transition: all 0.4s ease;
}

input[type=range]::-webkit-slider-thumb {
  height: 16px;
  width: 16px;
  border-radius: 16px;
  background: $primary_color;
  cursor: pointer;
  -webkit-appearance: none;
  margin-left: -1px;
}

input[type=range]:focus::-webkit-slider-runnable-track {
  background: transparent;
}

input[type=range].volume {
  height: 5px;
  background-color: transparent;
  border-radius: 10px;
  position: absolute;
  width: 100%;
}

input[type=range].volume::-webkit-slider-runnable-track {
  background-color: transparent;
}

input[type=range].volume::-webkit-slider-thumb {
  margin-left: 0;
  height: 14px;
  width: 14px;
  background: $color_light;
}

input[type=range]::-moz-range-track {
  width: 100%;
  height: 8.4px;
  cursor: pointer;
  border: 0;
  background: transparent;
  border-radius: 1.3px;
}

input[type=range]::-moz-range-thumb {
  height: 14px;
  width: 14px;
  border-radius: 50px;
  border: 1px solid $primary_color;
  background: $primary_color;
  cursor: pointer;
  margin-top: 5px;
}

input[type=range]:focus::-moz-range-track {
  outline: none;
}

input[type=range].volume::-moz-range-thumb {
  border: 1px solid $color_light;
  background: $color_light;
}
@media screen and ( max-width: 767px ) {
  .ebook-media {
    &__footer {
      height: auto;

      &__main {
        display: block;
        padding: 5px 15px;

        >* {
          &:not(:last-child) {
            margin-bottom: 10px;
          }
        }
      }
    }

    &__list {
      &.active {
        bottom: 140px;
      }
    }

    &__back {
      padding: 0;

      >span {
        margin-right: 0;
      }
    }
  }

  .playback-icons {
    width: 35px;
    height: 35px;
  }
}
@media screen and ( max-width: 576px ) {
  .volume-controls__progress {
    min-width: 80px;
  }
}
</style>